import Slide from '@mui/material/Slide';
import * as React from 'react';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="left" ref={ref} {...props} />
));

export default Transition;
